import { createContext, useContext } from 'react'

export type renderedComponentContextType = {
  renderedComponentName: string
  setRenderedComponentName: React.Dispatch<React.SetStateAction<string>>
}

export const RenderedComponentContext =
  createContext<renderedComponentContextType>(
    null as unknown as renderedComponentContextType
  )

export const useRenderedComponentContext = () =>
  useContext(RenderedComponentContext)
